import styled from 'styled-components'

const Circle = styled.button`
  background: rgb(255, 255, 255);
  border-radius: 100%;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  margin: 6px 0 0 6px;
  display: flex;
  z-index: 1;
`

export default Circle
